import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoginStep1 from "./Auth/LoginStep1";
import LoginStep2 from "./Auth/LoginStep2";
import {
  getCurrentUser,
  getLoggedUser,
  getLoginFailedStatus,
  loginFailed,
  sign,
} from "../app/store/auth";

const Login = () => {
  const [validId, setValidId] = useState("");
  const [userPwd, setUserPwd] = useState("");
  const [stateErrors, setStateErrors] = useState("");
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [isSigningIn, setIsSigningIn] = useState(false);

  const usrType = localStorage.getItem("userType");

  const loggedUserSeletor = useSelector(getLoggedUser);
  const loginFailedStatusSelector = useSelector(getLoginFailedStatus);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    const state = location.state;
    if (state?.validId) {
      setValidId(state.validId);
      setStep1(false);
      setStep2(true);
    }
  }, [location.state]);

  useEffect(() => {
    if (loggedUserSeletor.user && !loggedUserSeletor.token) {
      localStorage.setItem("tempPwd", userPwd);
      navigate("/ValidateUser");
    } else {
      if (currentUser) {
        navigate("/");
      }
    }
    if (currentUser) {
      navigate("/");
    }
  }, [currentUser, loggedUserSeletor, navigate, userPwd]);

  useEffect(() => {
    if (loginFailedStatusSelector !== "") {
      setStateErrors("Username or password is incorrect");
      setIsSigningIn(false);
      dispatch(loginFailed(""));
    }
  }, [dispatch, loginFailedStatusSelector]);

  const handleStep1 = (step1Data) => {
    if (step1Data?.validId) {
      setStep1(false);
      setStep2(true);
      setValidId(step1Data.validId);
    }
  };

  const doSubmit = async (step2Data) => {
    setIsSigningIn(true);
    dispatch(sign(step2Data.username, step2Data.password));
    setUserPwd(step2Data.password);
  };

  const handleBack = () => {
    setStep1(true);
    setStep2(false);
    setValidId("");
    localStorage.removeItem("userType");
  };

  const handleForgotPwd = () => {
    navigate("/ForgotPassword", { state: { validId } });
  };

  return (
    <React.Fragment>
      {step1 && (
        <div className="login-page">
          <div className="login-shell">
            <section className="login-hero" aria-label="WorkFINITY platform overview">
              <div className="login-brand-mark">
                <img alt="WorkFINITY" src="/assets/Img/logo_ft.png" />
              </div>
              <p className="login-kicker">Subcontractor, recruiter and candidate portal</p>
              <h1>Secure access to your WorkFINITY&reg; AI driven technology Framework</h1>
              {/* <p className="login-copy">
                Continue your onboarding, documents, invoices, support activity, and partner workflows from one focused portal.
              </p> */}
              <div className="login-highlights" aria-label="Portal capabilities">
                <span>Onboarding</span>
                <span>Contracts</span>
                <span>Time Logs</span>
                <span>Invoices</span>
              </div>
            </section>

            <section className="login-panel" aria-label="Sign in">
              <div className="login-card">
                <div className="login-card-header">
                  <p className="login-step-label">Step 1 of 2</p>
                  <h2>Sign in</h2>
                  <p>Enter your Valid ID to continue.</p>
                </div>
                <LoginStep1
                  handleStep1={handleStep1}
                  userError={stateErrors}
                  type="admin"
                ></LoginStep1>
                <div className="login-card-actions">
                  <Link to="/ForgotValidID" className="btn btn-link btn-sm login-link">
                    Forgot Valid ID?
                  </Link>
                </div>
                <div className="login-support">
                  Customer Support:{" "}
                  <a href="mailto:Support@workfinity.com">
                    Support@workfinity.com
                  </a>
                </div>
              </div>
            </section>
          </div>
        </div>
      )}

      {step2 && (
        <div className="login-page">
          <div className="login-shell">
            <section className="login-hero" aria-label="Selected account context">
              <div className="login-brand-mark">
                <img alt="WorkFINITY" src="/assets/Img/logo_ft.png" />
              </div>
              <p className="login-kicker">Step 2 of 2</p>
              <h1>Welcome back</h1>
              <p className="login-copy">
                Complete secure access for this portal account using your username, password, and captcha verification.
              </p>
              <div className="login-hero-account">
                <div>
                  <span>User Type</span>
                  <span><strong>{usrType}</strong></span>
                </div>
                <div>
                  <span>Valid ID</span>
                  <strong>{validId}</strong>
                </div>
              </div>
            </section>

            <section className="login-panel" aria-label="Sign in credentials">
              <div className="login-card">
                <div className="login-card-header">
                  <button className="btn btn-link btn-sm login-back" onClick={handleBack}>
                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                    Back
                  </button>
                  <p className="login-step-label">Step 2 of 2</p>
                  <h2>Sign in</h2>
                  <p>Complete your sign in with your username and password.</p>
                </div>
                <LoginStep2
                  handleDoSubmit={doSubmit}
                  userError={stateErrors}
                  handleForgotPwd={handleForgotPwd}
                  isProcessing={isSigningIn}
                  type="admin"
                ></LoginStep2>
                <div className="login-support">
                  Customer Support:{" "}
                  <a href="mailto:Support@workfinity.com">
                    Support@workfinity.com
                  </a>
                </div>
              </div>
            </section>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Login;
